class CodeTypeEnum {
    static JSON = 'application/json';
    static XML = 'application/xml';
}

export {CodeTypeEnum}